import { useEffect, useState } from "react";
import { Stack, Typography, Box, Paper, Button, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { RefreshOutlined } from "@mui/icons-material";
// export buttons temporarily disabled
import dayjs from "dayjs";
import { CallTrendChart, convertToCallChartData, generateCallTrendData } from ".";
import { useGetDailyCallAnalytics } from "../../../../../../features/analytics/hooks/useGetDailyCallAnalytics";
import { CALL_TYPE_OPTIONS, DEFAULT_SELECTED_TYPE } from './graph';
import DailyCallTotals from './components/DailyCallTotals';
import DailyCallType from './components/DailyCallType';
import { useAnalyticsSyncDate } from "../../context/analytics-sync-date.context";
import CallTrendAnalyticsDateRangeFilter from "./components/call-trend-analytics-date-range-filter";
// export hooks temporarily disabled

export const CallTrendView = (props) => {
  // The view no longer manages a global selected month. Child components use their own
  // DateRangePicker with from/to ranges (defaults to current month's start/end).
  const { fromDate: syncedFromDate, toDate: syncedToDate, enableDateSync } = useAnalyticsSyncDate();

  // Local global state so that the two charts here can be synced with it
  // The global sync date context will also work
  // if the enable sync is true
  const [fromDate, setFromDate] = useState(() => enableDateSync ? dayjs(syncedFromDate) : dayjs().startOf('month'));
  const [toDate, setToDate] = useState(() => enableDateSync ? dayjs(syncedToDate) : dayjs().endOf('month'));

  useEffect(() => {
    if (!enableDateSync) {
      return;
    }

    if (syncedFromDate) {
      setFromDate(dayjs(syncedFromDate));
    }

    if (syncedToDate) {
      setToDate(dayjs(syncedToDate));
    }
  }, [syncedFromDate, syncedToDate, enableDateSync]);

  useEffect(() => {
    console.log('CallTrendView sync date context', {
      fromDate: syncedFromDate,
      toDate: syncedToDate,
      enableDateSync,
    });
  }, [syncedFromDate, syncedToDate, enableDateSync]);

  const handleRefresh = () => {
    // no-op here; children manage their own refreshes
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
  }

  const handleToDateChange = (newDate) => {
    setToDate(newDate);
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        p: 3,
        border: "2px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        overflowX: "auto",
        mb: 1,
      }}
    >

      <CallTrendAnalyticsDateRangeFilter
        fromDate={fromDate}
        toDate={toDate}
        onFromChange={handleFromDateChange}
        onToChange={handleToDateChange}
      />

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3} sx={{ flexGrow: 1 }}>
          {/* <Typography variant="h4" gutterBottom>
            Call Trend Analytics
          </Typography> */}

          {/* Daily call totals and types chart */}
          <DailyCallTotals
            title={`Daily Calls`}
            height={380}
            fromDate={fromDate}
            toDate={toDate}
            onFromDateChange={handleFromDateChange}
            onToDateChange={handleToDateChange}
          />

          {/* Daily call-type answered vs notAnswered chart */}
          <DailyCallType
            title={`Daily Call Type`}
            height={380}
            fromDate={fromDate}
            toDate={toDate}
            onFromDateChange={handleFromDateChange}
            onToDateChange={handleToDateChange}
          />

        </Stack>
      </LocalizationProvider>
    </Box>
  );
};
